import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import {
  distinct,
  CompositeFilterDescriptor,
  filterBy,
  FilterDescriptor,
} from '@progress/kendo-data-query';
import { FilterService } from '@progress/kendo-angular-grid';

@Component({
  selector: 'app-multicheck-filter',
  templateUrl: './multicheck-filter.component.html',
  styleUrls: ['./multicheck-filter.component.scss'],
})
export class MulticheckFilterComponent implements AfterViewInit {
  @Input() public isPrimitive!: boolean;
  @Input() public currentFilter!: CompositeFilterDescriptor;
  @Input() public data!: any;
  @Input() public textField!: any;
  @Input() public valueField!: any;
  @Input() public filterService!: FilterService;
  @Input() public field!: string;
  @Output() public valueChange = new EventEmitter<number[]>();

  public currentData!: unknown[];
  public showFilter = true;
  private value: unknown[] = [];

  public textAccessor = (dataItem: any): string =>
    this.isPrimitive ? dataItem : dataItem[this.textField];
  public valueAccessor = (dataItem: any): unknown =>
    this.isPrimitive ? dataItem : dataItem[this.valueField];

  constructor() {}

  public ngAfterViewInit(): void {
    this.currentData = this.data;
    this.value = this.currentFilter.filters.map((f: any) => f.value);

    this.showFilter =
      typeof this.textAccessor(this.currentData[0]) === 'string';
  }

  public isItemSelected(item: unknown): boolean {
    return this.value.some((x) => x === this.valueAccessor(item));
  }

  public onSelectionChange(item: unknown, li: HTMLLIElement): void {
    if (this.value.some((x) => x === item)) {
      this.value = this.value.filter((x) => x !== item);
    } else {
      this.value.push(item);
    }

    this.filterService.filter({
      filters: this.value.map((value) => ({
        field: this.field,
        operator: 'eq',
        value,
      })),
      logic: 'or',
    });

    this.onFocus(li);
  }

  public onInput(e: Event): void {
    this.currentData = distinct(
      [
        ...this.currentData.filter((dataItem) =>
          this.value.some((val) => val === this.valueAccessor(dataItem))
        ),
        ...filterBy(this.data, {
          operator: 'contains',
          field: this.textField,
          value: (e.target as HTMLInputElement).value,
        }),
      ],
      this.textField
    );
  }

  public onFocus(li: HTMLLIElement): void {
    const ul = li.parentNode as HTMLUListElement;
    const below =
      ul.scrollTop + ul.offsetHeight < li.offsetTop + li.offsetHeight;
    const above = li.offsetTop < ul.scrollTop;

    // Scroll to focused checkbox
    if (above) {
      ul.scrollTop = li.offsetTop;
    }

    if (below) {
      ul.scrollTop += li.offsetHeight;
    }
  }
}
